/* tslint:disable */
export const ar_overrides_strings: Record<string, string> = {
  'AddressLine1': 'العنوان الخط الأول',
  'AddressLine2': 'العنوان الخط الثاني',
  'AddressLine3': 'العنوان الخط الثالث',
  'all.reviews': 'جميع المراجعات على هذا الطلب، مع التاريخ والمستخدم الذي قام بالمراجعة.',
  'apipnrFound': 'يقوم التطبيق <ب> بمطابقة قائمة API/PNR</b>',
  'application.overStay': 'الطلب هو <ب>في حالة تجاوز الحد المسموح به</b>',
  'ask.downgrade': 'هل أنت متأكد من رغبتك في تخفيض هذا الطلب إلى تأشيرة دخول واحدة؟ لا يمكن التراجع عن هذا الإجراء.',
  'ask.noticePrint': 'هل ترغب في طباعة الإشعار بتاريخ {التاريخ} ؟',
  'ask.selectNotice': 'يرجى تحديد الإشعار الذي تريد طباعته.',
  'ask.updateForHKG': 'هل أنت متأكد من رغبتك في تحديث هذا التطبيق إلى تطبيق هونغ كونغ؟',
  'ask.updateManuallyPassport': 'هل أنت متأكد من رغبتك في تحديث بيانات التطبيق يدوياً؟',
  'askSupervisorReview': 'ما هي توصيتك؟ سيتم إرسال مراجعتك إلى المشرف للموافقة عليها.',
  'BirthDay': 'تاريخ الميلاد ',
  'BirthExtract': 'مستخرج شهادة الميلاد',
  'BLACK': 'أسود',
  'BLOND': 'أشقر',
  'BLUE': 'أزرق',
  'BROWN': 'بني',
  'cancel.draft': 'هذا الطلب حاليًا في حالة "في انتظار الدفع". يشير هذا إلى أن البنك الذي تتعامل معه لا يزال يعالج عملية الدفع، أو أن هناك مشكلة أثناء عملية إنشاء الطلب. إذا لزم الأمر، لديك خيار إلغاء طلب الطلب هذا في أي وقت. <br /><br />هل تريد حقًا إلغاء هذا الطلب تحت حالة "في انتظار الدفع"؟',
  'cancelled': 'تم الإلغاء',
  'changeToHKG': 'التغيير إلى تطبيق هونغ كونغ',
  'checkin': 'تسجيل الوصول',
  'checkout': 'تسجيل المغادرة',
  'CHESTNUT': 'كستنائي',
  'client.extended.noValidPerson': 'لم يتم العثور على شخص مرتبط بهذه الدفعة. يرجى التحقق من قائمة الأشخاص المحفوظة والمحاولة مرة أخرى.',
  'CompanionsSize': 'عدد رفقاء السفر',
  'completedApplications': 'تم إنشاء التطبيقات التالية بنجاح للأفراد التالية أسماؤهم: <ب>{الأشخاص}</ب>. بسبب مشكلة الدفع، لم يتم إنشاء التطبيق (التطبيقات) التي تتطلب الدفع. يمكنك إعادة إنشائها هنا.',
  'createNewOne': 'إنشاء واحدة جديدة',
  'deletePerson.error.DYN.': 'حدث خطأ أثناء حذف الشخص. لا يمكنك حذف شخص لديه طلب تم إرساله بالفعل.',
  'deportedMode': 'وضع علامة كمرحّل',
  'disclaimerPermit': 'إذا كان رقم إقامتك مثبتاً في جواز سفرك، يرجى إدخال رقم جواز سفرك كرقم تصريح الإقامة. إذا كان لديك بطاقة إقامة، استخدم رقم الوثيقة الموجودة على البطاقة.',
  'divers.data.DYN.': 'تفاصيل الطلب',
  'done.revertConsume': 'تم إلغاء الفعالية بنجاح',
  'done.updateForHKG': 'لقد تم تحديث التطبيق بنجاح إلى تطبيق هونغ كونغ',
  'done.updatePassport': 'تم تحديث بيانات جواز السفر يدوياً بنجاح',
  'doSupervisorReview': 'هل ترغب في الموافقة على هذا الطلب أو رفضه؟ بناءً على قرارك، سيتمكن ضابط الحدود من تسجيل دخول مقدم الطلب أو رفضه.',
  'draft.cancelled.error': 'حدث خطأ أثناء إلغاء التطبيق. يرجى المحاولة مرة أخرى.',
  'DriverLicenseNumber': 'رقم رخصة القيادة',
  'DYN.APPLICATION': 'التطبيق',
  'DYN.BORDER_PASS': 'تصريح مرور الحدود',
  'DYN.CANCELLED': 'لقد تم إلغاء عملية الدفع الخاصة بك. إذا كنت تريد التحقق من صحة طلبك، يُرجى إعادة تشغيل عملية الدفع أو إلغاء طلبك مباشرةً من خلال تفاصيل الطلب.',
  'DYN.engaged': 'متزوج',
  'DYN.ENGAGED': 'متزوج',
  'DYN.in_a_civil_union': 'في عقد حالة الزواج',
  'DYN.IN_A_CIVIL_UNION': 'في عقد حالة الزواج',
  'DYN.in_a_domestic_partnership': 'في عقد حالة الزواج',
  'DYN.IN_A_DOMESTIC_PARTNERSHIP': 'في عقد حالة الزواج',
  'DYN.INVALID_CARD_NUMBER': 'رقم البطاقة الذي أدخلته <b>غير صالح</b>. يرجى التحقق من الرقم والمحاولة مرة أخرى، أو إلغاء طلبك مباشرة من خلال تفاصيل الطلب.',
  'DYN.OTHER': 'أخرى',
  'DYN.payment_text.zweentry': '<p>هذا الطلب هو لـ <b>الدخول بدون تأشيرة</b>.</p>',
  'DYN.paymentError.desc.success': '<p>تم تسجيل طلبك بنجاح. سيتم إعلامك عندما يتم معالجة طلبك أو إذا كانت المعلومات الإضافية مطلوبة.</p>',
  'DYN.processed.IN': 'تسجيل الوصول',
  'DYN.processed.INRETURNED': 'تسجيل الوصول مع حالة الترحيل',
  'DYN.processed.OUT': 'تسجيل المغادرة',
  'DYN.processed.REFUSEIN': 'الرفض عند تسجيل الوصول',
  'DYN.processed.REFUSEOUT': 'الرفض عند المغادرة',
  'DYN.processed.TRANSIT': 'النقل العابر',
  'DYN.REPORTING': 'إعداد التقارير',
  'DYN.scanPassport.badFields': 'يحتوي {المستند} الذي تم مسحه ضوئياً على حقول لا يمكن قراءتها. يرجى مراجعة وتصحيح جميع الحقول للمتابعة في الطلب.',
  'DYN.SEPARATED': 'مطلق',
  'DYN.STICKER': 'الملصقات',
  'DYN.UNKNOW_ERROR': 'حدث <b> خطأ غير معروف</b> أثناء عملية الدفع. يرجى المحاولة مرة أخرى، أو إلغاء طلبك مباشرةً من خلال تفاصيل الطلب.',
  'err.AddressLine1.maxlength': 'العنوان الخط الأول يجب أن يكون أقل من 50 حرف',
  'err.AddressLine1.pattern': 'العنوان الخط الأول يمكن أن يحتوي على أحرف وأرقام وعلامات ترقيم ورموز',
  'err.AddressLine1.required': 'العنوان الخط الأول مطلوب',
  'err.AddressLine2.maxlength': 'العنوان الخط الثاني يجب أن يكون أقل من 50 حرف',
  'err.AddressLine2.pattern': 'العنوان الخط الثاني يمكن أن يحتوي على أحرف وأرقام وعلامات ترقيم ورموز',
  'err.AddressLine2.required': 'العنوان الخط الثاني مطلوب',
  'err.AddressLine3.maxlength': 'العنوان الخط الثالث يجب أن يكون أقل من 50 حرف',
  'err.AddressLine3.pattern': 'العنوان الخط الثالث يمكن أن يحتوي على أحرف وأرقام وعلامات ترقيم ورموز',
  'err.AddressLine3.required': 'العنوان الخط الثالث مطلوب',
  'err.approveRefuse.required': 'حالة المراجعة مطلوبة',
  'err.BirthCity.pattern': 'مدينة الميلاد يجب أن تحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.BirthCountry.required': 'بلد الميلاد مطلوب',
  'err.birthDate.maxDate': 'يجب أن يكون تاريخ الميلاد قبل اليوم',
  'err.birthDate.required': 'تاريخ الميلاد مطلوب',
  'err.birthDay.required': 'تاريخ الميلاد مطلوب',
  'err.BirthExtract.required': 'مستخرج شهادة الميلاد مطلوب',
  'err.BirthExtractNumber.maxlength': 'رقم مستخرج شهادة الميلاد يجب أن يكون أقل من 50 حرف',
  'err.BirthExtractNumber.pattern': 'رقم مستخرج شهادة الميلاد يجب أن يحتوي على 10 أرقام بالضبط',
  'err.cashType.required': 'طريقة الدفع مطلوبة',
  'err.CompanionsSize.required': 'عدد رفقاء السفر مطلوب',
  'err.documentNumber.required': 'مطلوب رقم جواز السفر',
  'err.DriverLicenseNumber.maxlength': 'رقم رخصة القيادة يجب أن يكون أقل من 50 حرف',
  'err.DriverLicenseNumber.pattern': 'رقم رخصة القيادة يجب أن يحتوي على 10 أرقام بالضبط',
  'err.DriverLicenseNumber.required': 'رقم رخصة القيادة مطلوب',
  'err.expirationDate.maxDate': 'يجب أن يكون تاريخ انتهاء الصلاحية أقل من 10 سنوات من اليوم',
  'err.expirationDate.minDate': 'يجب أن يكون تاريخ انتهاء الصلاحية بعد اليوم',
  'err.expirationDate.required': 'تاريخ انتهاء الصلاحية مطلوب',
  'err.EyeColor.required': 'لون العيون مطلوب',
  'err.FatherFirstName.maxlength': 'اسم الأب يجب أن يكون أقل من 50 حرف',
  'err.FatherFirstName.pattern': 'اسم الأب يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.FatherFirstName.required': 'اسم الأب مطلوب',
  'err.FatherLastName.maxlength': 'اسم الأب يجب أن يكون أقل من 50 حرف',
  'err.FatherLastName.pattern': 'اسم الأب يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.FatherLastName.required': 'اسم الأب مطلوب',
  'err.FirstName.maxlength': 'الاسم الأول يجب أن يكون أقل من 50 حرف',
  'err.FirstName.pattern': 'الاسم الأول يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.Gender.required': 'الجنس مطلوب',
  'err.HairColor.required': 'لون الشعر مطلوب',
  'err.Height.max': 'الطول يجب أن يكون أقل من 300 سم',
  'err.Height.required': 'الطول مطلوب',
  'err.internalReference.pattern': 'يجب أن يكون للمرجع الداخلي تنسيق صحيح',
  'err.internalReference.required': 'مطلوب مرجع داخلي',
  'err.LastName.maxlength': 'اسم العائلة يجب أن يكون أقل من 50 حرف',
  'err.LastName.pattern': 'اسم العائلة يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.localUsageUntil.max': 'يجب ألا يتجاوز الحد المسموح به.',
  'err.localUsageUntil.min': 'يجب أن يكون يوم واحد على الأقل من اليوم.',
  'err.localUsageUntil.pattern': 'يجب أن تكون نهاية الإقامة رقمًا',
  'err.localUsageUntil.required': 'نهاية الإقامة مطلوبة',
  'err.MaidenName.pattern': 'اسم الأم يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.MaidenName.required': 'اسم الأم مطلوب',
  'err.MaritalStatus.required': 'الحالة المهنية مطلوبة',
  'err.MotherFirstName.maxlength': 'اسم الأم يجب أن يكون أقل من 50 حرف',
  'err.MotherFirstName.pattern': 'اسم الأم يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.MotherFirstName.required': 'اسم الأم مطلوب',
  'err.MotherLastName.maxlength': 'اسم الأم يجب أن يكون أقل من 50 حرف',
  'err.MotherLastName.pattern': 'اسم الأم يجب أن يحتوي على أحرف ومسافات وشرطات ونقاط وعلامات اقتباس فقط',
  'err.MotherLastName.required': 'اسم الأم مطلوب',
  'err.NextOfKin.required': 'هذا الحقل مطلوب',
  'err.NNI.maxlength': 'رقم الهوية الوطنية (NNI) يجب أن يكون أقل من 50 حرف',
  'err.NNI.pattern': 'يجب أن يكون رقم الهوية الوطنية (NNI) بالتنسيق الصحيح (10 أرقام)',
  'err.NNI.required': 'رقم الهوية الوطنية (NNI) مطلوب',
  'err.OtherName.required': 'الاسم الآخر مطلوب',
  'err.passportNumber.required': 'مطلوب رقم جواز السفر',
  'err.passportType.required': 'نوع جواز السفر المطلوب',
  'err.paymentMethod.required': 'طريقة الدفع مطلوبة',
  'err.paymentReference.required': 'مرجع الدفع مطلوب',
  'err.Phone.pattern': 'رقم الهاتف يجب أن يحتوي على 10 أرقام بالضبط',
  'err.Phone.required': 'رقم الهاتف مطلوب',
  'err.Photo.required': 'صورة وجه مقدم الطلب مطلوبة',
  'err.PlaceOfBirthCity.maxlength': 'المدينة المولد يجب أن يكون أقل من 50 حرف',
  'err.PreviousPassportNumber': 'رقم جواز السفر السابق مطلوب',
  'err.PreviousPassportNumber.maxlength': 'رقم جواز السفر السابق يجب أن يكون أقل من 50 حرف',
  'err.PreviousPassportNumber.pattern': 'يجب أن يكون رقم جواز السفر السابق بالتنسيق الصحيح (10 أرقام)',
  'err.purposeOfVisit.required': 'الغرض من الزيارة مطلوب',
  'err.refusalReason.required': 'الوصف مطلوب',
  'err.RegistrationPortId.required': 'نقطة التسجيل المطلوبة مطلوبة',
  'err.ResidenceCertificate.required': 'شهادة الإقامة مطلوبة',
  'err.selectedNotice.required': 'مطلوب اختيار الإشعار',
  'err.selectedReceipt.required': 'مطلوب اختيار الإيصال',
  'err.SpouseFullName.pattern': 'يجب أن يكون اسم الزوج أو الزوجة بصيغة صحيحة',
  'err.summary.accept.all': 'يجب عليك قبول جميع البيانات عن طريق تحديد المربعات المقابلة قبل المتابعة في طلبك.',
  'err.supervisorAccountName.required': 'مطلوب اسم حساب المشرف',
  'errNoCard.modify': 'تعديل بيانات التطبيق يدوياً',
  'error.updateForHKG': 'حدث خطأ أثناء تحديث التطبيق إلى تطبيق هونغ كونغ. يرجى المحاولة مرة أخرى.',
  'existing.draftPayment': 'يوجد طلب دفع سابق لهذا الطلب. هل تريد المتابعة وإنشاء طلب جديد، أو إلغاء هذا النموذج وانتظار معالجة الطلب السابق؟',
  'extension.insufficientRights': 'طلب التمديد هذا <b> لم يتم الانتهاء منه بعد</b>. ليس لديك الأذونات اللازمة لمتابعة عملية التحقق من الصحة.',
  'FatherFirstName': 'اسم الأب',
  'FatherLastName': 'اسم الأب',
  'form.password2': 'تأكيد كلمة المرور',
  'form.perm1.DYN.': 'دفع طلب وثيقة',
  'form.perm1.DYN.makePayment': 'إجراء دفعة',
  'form.role.worker': 'ضابط',
  'global.checkIn.withoutCamera': 'تسجيل الوصول بدون كاميرا',
  'global.checkOut.notice': 'تسجيل المغادرة بإشعار',
  'global.checkOut.withCamera': 'تسجيل المغادرة بالكاميرا',
  'global.checkOut.withoutCamera': 'تسجيل المغادرة بدون كاميرا',
  'global.connect': 'تسجيل الدخول',
  'global.deported': 'الترحيل',
  'global.goLatest': 'افتح أحدث تطبيق تمت زيارته',
  'global.refuseIn': 'الرفض عند تسجيل الوصول',
  'global.refuseNoCam': 'رفض بدون كاميرا',
  'global.refuseOut': 'الرفض عند المغادرة',
  'GRAY': 'رمادي',
  'GRAY_WHITE': 'رمادي/أبيض',
  'GREEN': 'أخضر',
  'HAZEL': 'بني',
  'Height': 'الطول (سم)',
  'internalReference.badPattern': 'يجب أن يتبع المرجع الداخلي صيغة "رقم_سنة" (على سبيل المثال، 140_2024).',
  'kiosk.qr.url': 'https://google.com/',
  'kiosk.standby.text1': 'ابدأ بملء طلبك للحصول على الوثيقة ببضع نقرات على هذا الجهاز اللوحي أو عبر الإنترنت.',
  'localUsageUntil.ask.invalid': 'أدخل الأيام',
  'MaidenName': 'اسم الأم',
  'marital.status.in_a_civil_union': 'في اتحاد مدني',
  'marital.status.in_a_domestic_partnership': 'في شراكة منزلية',
  'MaritalStatus': 'الحالة المهنية',
  'miscellaneous_details': 'تفاصيل الوثيقة',
  'MotherFirstName': 'اسم الأم',
  'MotherLastName': 'اسم الأم',
  'NNI': 'رقم الهوية الوطنية (NNI)',
  'no_trips': 'ليس لديك أي طلبات.',
  'noChoice.selectedNotice': 'لم يتم تحديد إشعار',
  'noScannedComparison': 'لم يتم العثور على بيانات مطابقة في التطبيق',
  'openDialog': 'افتح نافذة الطابعة',
  'OTHER': 'آخر',
  'otherState.delayPay': 'يتطلب هذا التطبيق الدفع في حالته الحالية. يتطلب فرض السداد موافقة المشرف.',
  'otherState.overStay': 'هذا التطبيق هو <b> في حالة تجاوزه لحالته الطبيعية. يتطلب إجباره على تسجيل الوصول موافقة المشرف.',
  'otherState.warning.ask': 'يرجى التحقق من المستند الذي قدمه العميل للتأكد من الحالة الدقيقة لهذا الطلب قبل المتابعة.',
  'outUsage.AB': 'م تجاوز موعد الموعد بأكثر من 24 ساعة. يلزم تقديم طلب جديد."',
  'outUsage.C': 'هذا الطلب هو <b> خارج فترة صلاحيته</b>. يُرجى إغلاق هذا الطلب، ثم إنشاء قيد جديد لمقدم الطلب ومتابعة الرفض.',
  'paidOnline': '(مدفوعة عبر الإنترنت)',
  'PARB_SEC17': 'الفقرة (ب) القسم 17',
  'ParentalApproval': 'موافقة الوالدين',
  'participant.draftWarn': 'هذا الشخص مرتبط حاليًا بطلب له دفعة معلقة. يُرجى التأكد من أن عملية الدفع لم تتم وأنها ليست ببساطة في انتظار المعالجة المصرفية قبل تقديم طلب آخر.',
  'participants.notAllValid': 'طلب واحد أو أكثر من طلبات المتقدمين <b> تنقصها معلومات إلزامية.</b> يرجى استكمالها لإنهاء الطلب.',
  'PARX_SUB1_SEC14': 'الفقرة الفرعية 1 من الفقرة العاشرة القسم الفرعي 1 القسم 14',
  'PARX_SUB3_SEC12': 'الفقرة الفرعية 3 من الفقرة العاشرة القسم الفرعي 3 القسم 12',
  'passport.scan': 'مسح جواز السفر',
  'passportType.changeToHKG': 'هل تريد حقاً تغيير التطبيق إلى تطبيق هونغ كونغ؟',
  'payment_status.desc.DYN.2.outFinish': 'تمت معالجة هذا الطلب. تم إصدار جواز السفر.',
  'payment_status.DYN.6': 'قيد التحقق',
  'payment_status.DYN.6-8': 'جميع الحالات قيد التحقق',
  'payment_status.DYN.6.finalReview': 'في انتظار التحقق',
  'payment_status.DYN.8': 'قيد التحقق – الدفع لاحقاً',
  'payment_status.DYN.9': 'مؤكد – الدفع لاحقاً',
  'payment.ask.printSticker': 'هل الملصق مطبوع؟',
  'payment.inReturned': 'تم تسجيل هذا الطلب بـ <b>تم تسجيل هذا الطلب بـ <b>حالة تم ترحيلها</b> في الضابط',
  'Payment.print': 'قسط',
  'paymentRef.edit': 'تحرير مرجع الدفع',
  'payOnArrival': 'أقر بأن الدفع في الموقع إلزامي',
  'pending.desc': 'طلب هذه الوثيقة في انتظار تصحيح من قبل العميل حالياً.',
  'pending.review.desc': 'لقد تم طلب تصحيح طلب الوثيقة هذا إلى مقدم الطلب في {date} من قبل المستخدم',
  'Photo': 'صورة وجه مقدم الطلب',
  'photo.entryCountry.INRETURNED': 'صورة عند تسجيل الوصول مع حالة الترحيل',
  'photo.entryCountry.REFUSEIN': 'صورة عند تسجيل الوصول مع حالة الرفض',
  'photo.entryCountry.REFUSEOUT': 'صورة عند تسجيل المغادرة مع حالة الرفض',
  'place.countriesSelected': 'اختر الدول التي ستتطلب دخولاً خاضعاً للإشراف',
  'place.notExist': 'المكان الذي اتصلت به لم يعد موجودًا، أو ربما تغير، أو ربما لم يعد بإمكانك الوصول إليه. يرجى تسجيل الدخول مرة أخرى.',
  'PreviousPassportNumber': 'رقم جواز السفر السابق',
  'print.desc.part1': 'يرجى الإذاعة إلى الموقع المحدد في التاريخ والوقت المحدد أدناه. يجب أن تصل في وقت مبكر.',
  'print.id': 'مرتبط بمعرف التطبيق',
  'print.notices': 'طباعة الإشعار (الإشعارات)',
  'print.settings.success': 'تم تحديث إعدادات الطباعة للمستند بنجاح: <b>{اسم المستند}</b>',
  'printApprovalLetter': 'طباعة البريد الإلكتروني للتأكيد',
  'printer.openSettings': 'افتح إعدادات الطابعة',
  'printerNotFound': 'لم يتم اكتشاف الطابعة الحرارية في قائمة الأجهزة. يرجى التحقق من الاتصال والتأكد من تثبيت برامج التشغيل. هل ما زلت ترغب في طباعة المستند باستخدام طابعة عادية؟',
  'printerOffline': 'الطابعة الحرارية غير متصلة. يرجى التحقق من اتصال USB بالجهاز والمحاولة مرة أخرى. هل ما زلت ترغب في طباعة المستند باستخدام طابعة عادية؟',
  'printOtherStateSticker': 'طباعة الملصق الخاص بالولاية الأخرى',
  'printSettings.desc': 'قم بتكوين إعدادات الطباعة لكل مستند: قم بتعيين الطابعات الافتراضية وضبط الخيارات (اللون، وضع المسودة) واختبار الطباعة. تقدم المطالبة بدائل إذا كانت الطابعة الافتراضية غير متوفرة.',
  'printSettings.selected': 'أنت تقوم بتعديل إعدادات الطباعة للمستند: <b>{اسم المستند}</b>',
  'processed.sessionBased': '<ب>البيانات المستندة إلى الجلسة. فُقدت عند تسجيل الخروج. </b>',
  'processed.title': '<b> التطبيقات المعالجة</b>',
  'processedSession': '{رقم}',
  'proposed.warn': 'هذا الطلب حاليًا في حالة "في انتظار الدفع". يشير هذا إلى أن البنك الذي تتعامل معه لا يزال يعالج عملية الدفع، أو أن هناك مشكلة أثناء عملية إنشاء الطلب. إذا لزم الأمر، لديك خيار إلغاء طلب الطلب هذا في أي وقت.',
  'qr.request_desc': 'يعمل هذا الرمز المرجعي كرمز لاسترجاع لطلبك.',
  'qrDesc.valid': 'اعرض هذا الرمز المرجعي عند نقطة الحجز المختارة.',
  'reactivateSession': 'تفعيل علامة التبويب هذه',
  'reasonAdd': '<p><p><b>السبب</b>: <p></> {السبب}</p> <p></p>',
  'RED': 'أحمر',
  'refugeeApplication': 'يتعلق هذا الطلب بـ <b>لاجئ</b>. يرجى التعامل معه بالحساسية والعناية اللازمتين.',
  'refusal.review.desc': 'تمت مراجعة هذا الطلب واعتباره مرفوضًا في {date} من قبل المستخدم.',
  'refusalReason.desc.extension.DYN.': '<p>يرجى تقديم وصف موجز لسبب رفض طلب التمديد هذا.</p>',
  'refusalReason.doSupervisor.desc.DYN.': 'يُرجى تقديم وصف موجز لـ <b>السبب في الرفض</b>. سيتم إرسال هذه الرسالة إلى ضابط الحدود.',
  'refusalReason.reviewSupervisor.desc.DYN.': 'يرجى تقديم وصف موجز للمراجعة على أنها <b>غير موصى بها</b>. سيتم إرسال المراجعة إلى المشرف للموافقة عليها.',
  'RegistrationPortId': 'نقطة التسجيل المطلوبة',
  'RenewDocument': 'هل تقوم بتجديد هذه الوثيقة؟',
  'RenewDocumentFile': 'الوثيقة السابقة (دليل التجديد)',
  'request.ask_supervisor_review': 'المراجعة للمشرف',
  'request.askSupervisorReview': 'تم إرسال مراجعتك بنجاح.',
  'request.do_supervisor_review.desc': 'يجوز للمشرف مراجعة الطلب للتأكد من أن المعلومات المقدمة دقيقة وأن الطلب متوافق مع الدولة ',
  'request.supervisor_review': 'يمكنك طلب مراجعة المشرف لهذا الطلب. سوف يقوم المشرف بمراجعة الطلب وستتمكن بعد ذلك من متابعة عملية تقديم الطلب.',
  'ResidenceCertificate': 'شهادة الإقامة',
  'review.otherRecords': 'عرض التطبيقات الأخرى',
  'rollWidth': 'عرض البكرة',
  'scan.alreadyIn': 'لقد قام هذا الشخص بالفعل بإجراء تسجيل دخول خلال آخر 15 دقيقة. هل أنت متأكد من عدم احتمال تكرار نفس الإجراء؟',
  'scan.alreadyOut': 'لقد قام هذا الشخص بالفعل بإجراء تسجيل مغادرة خلال آخر 15 دقيقة. هل أنت متأكد من عدم احتمال تكرار نفس الإجراء؟',
  'scan.choice': 'تحديد الوضع',
  'scan.fingerprintSupervisor.desc': 'عندما تكون جاهزًا، بصفتك المشرف، ضع إصبعك على الماسح الضوئي وانقر على <b>المسح الآن</b> للمتابعة مع الإجراء التالي:</br><b>{نص الإجراء}</b>',
  'scan.now': 'المسح الآن',
  'scan.supervisor.desc': 'الرجاء إدخال اسم الحساب الخاص بالمشرف لمتابعة الإجراء التالي:</br><b>{actionText}</b>',
  'scan.supervisor.noAccountName': 'لم يتم توفير اسم حساب المشرف',
  'scan.supervisor.noFingerprint': 'لم يتم العثور على أي بيانات بصمات أصابع لهذا المشرف ',
  'scan.supervisor.timeout': 'هل ترغب في تجاوز فحص المشرف؟',
  'scan.supervisor.wrongFingerprint': 'البصمة لا تتطابق مع المشرف المشرف',
  'scan.timeout': 'حدث خطأ على الخادم أثناء البحث. هل ترغب في إعادة محاولة العثور على التطبيق المقابل أو إنشاء تطبيق جديد بالبيانات الممسوحة ضوئياً؟',
  'scanTimeout.create': 'إنشاء تطبيق جديد',
  'select.notice': 'حدد الإشعار المراد طباعته',
  'session.inactive': 'يدعم هذا التطبيق جلسة عمل نشطة واحدة فقط في كل مرة. لديك حالياً جلسة أخرى مفتوحة في علامة تبويب مختلفة. يمكنك اختيار تنشيط علامة التبويب هذه، مما يؤدي إلى إلغاء تنشيط علامة التبويب الأخرى. لتجنب تعارض الجلسات، نوصي بإبقاء علامة تبويب واحدة فقط مفتوحة.',
  'showcase.ctaSubtitle': 'بوابة واحدة. جميع وثائقك الرسمية — {docs} — تقدم بطلبها وتتبعها واستلمها شخصياً.',
  'showcase.ctaTitle': 'وثائقك،<br/><em>عبر الإنترنت.</em>',
  'showcase.flowSubtitle': '{name} يرشدك خلال كل مرحلة من مراحل طلبك — حتى تعرف دائماً أين أنت وما يأتي بعد ذلك.',
  'showcase.flowTitleMain': 'أربع خطوات.<br/><em>بوابة واحدة.</em>',
  'showcase.flowTitleSub': 'طلب وثيقتك، معالج رقمياً.',
  'showcase.heroCta1': 'بدء الطلب',
  'showcase.heroCta2': 'تتبع طلبي',
  'showcase.heroSubtitle': 'قدم طلبك للحصول على جواز سفر أو بطاقة هوية وطنية أو تصريح إقامة عبر الإنترنت. {name} يعالج ويتابع كل طلب في الوقت الفعلي، من التقديم إلى التسليم.',
  'showcase.heroTitle': 'وثائقك،<br/><em>معالجة رقمياً.</em>',
  'showcase.portalType': 'بوابة خدمات الوثائق',
  'showcase.step1.label': 'ملء الطلب',
  'showcase.step1.paneDesc': 'اختر نوع الوثيقة وأدخل بياناتك الشخصية…',
  'showcase.step1.paneTitle': 'اختر نوع الوثيقة',
  'showcase.step2.paneDesc': 'شهادة الميلاد وإثبات الإقامة والوثائق الحالية…',
  'showcase.step2.paneTitle': 'إرفاق الملفات المطلوبة',
  'showcase.step3.label': 'التحقق والمراجعة',
  'showcase.step3.paneDesc': 'تتم مراجعة وثائقك ومقارنتها والتحقق منها…',
  'showcase.step3.paneTitle': 'التحقق من الهوية',
  'showcase.step4.label': 'تم إصدار الوثيقة',
  'showcase.step4.paneDesc': 'تمت معالجة وثيقتك وهي جاهزة للاستلام…',
  'showcase.step4.paneTitle': 'جاهز للاستلام',
  'showcase.tl.step1': 'المعلومات الشخصية',
  'showcase.tl.step3': 'المراجعة',
  'showcase.tl.step4': 'الإصدار',
  'sinceOneWeek': 'يرجى ملاحظة أن طلب هذه الوثيقة كان قيد المراجعة لأكثر من أسبوع.',
  'SUB1_SEC18': 'القسم الفرعي 1 القسم 18',
  'SUBPARIII_PARF_SUB1_SEC14': 'الفقرة الفرعية الثالثة الفقرة الفرعية (و) القسم الفرعي 1 القسم 14 الفقرة الفرعية 1',
  'summary.accept.conditions': 'يرجى قراءة وقبول البيانات التالية عن طريق تحديد المربعات المقابلة.',
  'summary.meta': 'بيانات الطلب (انقر للإطلاع)',
  'summary.payOnline': 'أود الدفع عبر الإنترنت الآن بدلاً من الدفع في المكتب المقري.',
  'summary.payOnline.desc': 'تحديد الخيار أدناه سيأخذك إلى صفحة الدفع. إذا اخترت الدفع خارج الإنترنت، سيتم إجراء الدفع في المكتب المقري.',
  'summary.warning_validity': '',
  'summary.zimswitch.desc': '<p>يرجى استخدام بطاقة مصرفية ممكّنة بتقنية 3D Secure.</p><p>يرجى تحديد طريقة الدفع المفضلة لديك لمتابعة الدفع.</p>',
  'supervision.blacklist': 'مقدم الطلب المدرج في القائمة السوداء',
  'supervision.manualCatC': 'القيد اليدوي لبلد من الفئة ج',
  'supervision.specifiedNationals': 'البلد الذي يتطلب الإشراف',
  'supervision.updateManuallyPassport': 'تحرير بيانات التطبيق يدوياً',
  'supervision.zweentry': 'الدخول الذي يتطلب مشرفاً/مشرفاً',
  'supervisorAccountName': 'اسم حساب المشرف',
  'timeslot': 'تاريخ ووقت الحجز',
  'timeslot_place_id': 'نقطة الحجز',
  'timeslot.notAvailable': 'لا توجد مهمة نشطة',
  'tooltip.allReviews': 'جميع المراجعات على هذا الطلب، مع التاريخ والمستخدم الذي قام بالمراجعة.',
  'tooltip.allSupervisions': 'قائمة بجميع المراجعات التي تم تقديمها فيما يتعلق بالإشراف على الطلب.',
  'tooltip.approve': 'وافق على هذا الطلب كقرار نهائي. يمكنك أيضًا إضافة تعليق. إذا كان المصطلح "محظور" موجودًا، فسيتم حظر الشخص.',
  'tooltip.checkInWithoutCamera': 'تسجيل دخول الشخص دون استخدام الكاميرا',
  'tooltip.checkOut.notice': 'تسجيل خروج الشخص خارج البلاد وطباعة الإشعار للزائر.',
  'tooltip.chooseLang': 'تغيير لغة التطبيق. حاليًا، تتوفر فقط الإنجليزية والفرنسية.',
  'tooltip.consumeRefuseNoCam': 'رفض الشخص دون استخدام الكاميرا',
  'tooltip.deportedMode': 'ضع علامة على الشخص كمرحّل. إذا قمت بتمييز الشخص على أنه مُرحّل، فسيتم اعتبار الشخص مُرحّل في النظام عند تسجيل دخول الشخص.',
  'tooltip.disabledBecauseDraft': 'هذا الشخص مرتبط حاليًا بطلب له دفعة معلقة. يُرجى الانتظار لمدة تصل إلى يوم واحد حتى يقوم البنك بمعالجة الدفع قبل المتابعة.',
  'tooltip.disabledBecauseReview': 'هذا الشخص مرتبط حالياً بطلب قيد المراجعة من قبل أحد المشرفين. لإنشاء طلب جديد لهذا الشخص، يجب عليك أولاً انتظار اكتمال المراجعة.',
  'tooltip.entryRegister': 'تسجيل دخول يدوي لشخص بدون وثيقة.',
  'tooltip.errNoCardModify': 'لديك خيار تعديل بيانات التطبيق يدوياً لتعذر قراءة شريحة جواز السفر.',
  'tooltip.exitRegister': 'تسجيل خروج يدوي لشخص بدون وثيقة.',
  'tooltip.forceComparison': 'قارن المعلومات بين المستند الممسوح ضوئياً والتطبيق.',
  'tooltip.goLatest': 'يمكنك العودة إلى التطبيق السابق الذي قمت بزيارته',
  'tooltip.paymentType': 'نوع الدفع لهذا الطلب.',
  'tooltip.printNotices': 'طباعة الإشعار (الإشعارات) التي طبعها الضابط أثناء عملية تسجيل الوصول أو الرفض',
  'tooltip.printSettings': 'تعيين إعدادات الطباعة لكل مستند من مستندات التطبيق',
  'tooltip.processedSession': 'عدد الطلبات التي تمت معالجتها خلال الدورة الحالية',
  'tooltip.refuse': 'رفض هذا الطلب كقرار نهائي. يمكنك أيضًا إضافة تعليق.',
  'tooltip.refuseFingerPrint': 'رفض الشخص صاحب البصمة',
  'tooltip.revertConsume': 'يمكنك إلغاء هذا الحدث من هذا التطبيق',
  'tooltip.review': 'راجع هذا الطلب كموافقة أو رفض وأضف تعليقًا.',
  'tooltip.revision': 'اطلب من العميل تصحيح طلب الوثيقة.',
  'tooltip.scanPassport': 'المسح الضوئي لجواز سفر الشخص',
  'tooltip.showFullDatas': 'إظهار أو إخفاء جميع مستندات التطبيق',
  'tooltip.transfertFromPassport': 'تختلف المعلومات بين جواز السفر والمستند الممسوح ضوئيًا. يمكنك نقل البيانات من المسح الضوئي إلى التطبيق.',
  'tooltip.transfertHKG': 'يمكنك وضع علامة على هذا الطلب على أنه طلب هونج كونج من جواز سفر صيني ممسوح ضوئيًا',
  'transfert.viewOutOfState.desc': '<b>تنبيه</b>، قد لا يكون هذا التطبيق بالحالة الصحيحة. يرجى التحقق بعناية من المستند الذي قدمه العميل للتأكد من الحالة الدقيقة لهذا التطبيق. نظرًا لأنك في وضع <b>{consumerMode}</b>، فلديك خيار <b>فإنك تملك خيار <b>فرض العملية كـ {transfertMode}</b>، حتى لو كانت الحالة الحالية لا تسمح بذلك عادة، إذا رأيت ذلك ضروريًا.',
  'transfertFromPassport': 'نقل البيانات من المسح الضوئي',
  'transfertHKG': 'ضع علامة على هذا التطبيق كتطبيق هونغ كونغ',
  'transit.consume': 'النقل العابر',
  'transit.register': 'تسجيل العبور',
  'validate.desc': 'تمت الموافقة على طلب الوثيقة هذا في {date} من قبل المستخدم',
  'warnPrinterNotConfigured': 'لم يتم تكوين الطابعة التي قمت بتحديدها لهذا المستند ({docName}) على هذا الجهاز. الرجاء فتح نافذة الطابعة لتحديد طابعة أخرى.',
  'warnPrinterOffline': 'الطابعة ({اسم الطابعة}) التي حددتها لهذا المستند ({اسم الطابعة}) غير متصلة. الرجاء التحقق من الاتصال بهذه الطابعة وإعادة المحاولة، أو افتح نافذة الطابعة لتحديد طابعة أخرى.',
  'warnPrinterZPLOffline': 'طابعة ZPL غير متصلة. يرجى التحقق من الاتصال بالجهاز ومحاولة إعادة طباعة الملصق.',
  'watchlist.null': '<ب>تعذّر التحقق من نظام {النظام}</b>',
  'watchlistFound': 'يقوم التطبيق <ب> بمطابقة قائمة المراقبة</b>',
  'zimswitch.cancel': 'العودة إلى الملخص',
  'zimswitch.desc': 'يُرجى التأكد من دقة جميع تفاصيل البطاقة (الرقم، وتاريخ انتهاء الصلاحية، وقيمة البطاقة CVV، واسم حامل البطاقة) لمعالجة عملية الدفع بنجاح وبشكل آمن.',
  'zimswitch.title': 'الدفع باستخدام Zimswitch',
  'zweentry.DYN.long_desc': '',
  'zwefeedback': 'نموذج ملاحظات البقاء'
};
